import { ViewModelCommon } from '../view-model-common/view-model-common';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import { SchedulingControlViewModel } from '../scheduling-control/scheduling-control-view-model';
import { TraySelectorType } from '../tray-selector/tray-selector.enum';
import { Channel } from '../../../domain/channel';
import { ProgramSelectorViewModel } from '../../../program-selector/components/program-selector/program-selector.view-model';

export enum ComingSoonForLiveTvChannelSubtype {
  UpcomingAtSpecificTime = 'Upcoming at specific time',
  ComingNext = 'Coming next',
}

export interface ComingSoonForLiveTvChannel {
  id: string;
  index: number;
  channel?: Channel;
  name: string;
  programSelector?: ProgramSelectorViewModel;
}

export interface ComingSoonForLiveTvTrayViewModel extends ViewModelCommon {
  id: string;
  type: TrayFormViewModelType.ComingSoonForLiveTvTray;
  scheduling: SchedulingControlViewModel;
  titleEnglish: string;
  titleArabic: string;
  displayServiceTypeIcon: boolean;
  countryIds: string[];
  userSegmentIds: string[];
  layout: TraySelectorType;
  channels: ComingSoonForLiveTvChannel[];
  subtype: ComingSoonForLiveTvChannelSubtype;
}
